module.exports = __webpack_public_path__ + "img/3.fa1ae923.jpg";